
import { Component, Vue } from "vue-property-decorator";
import PortfolioTableHeaderCell from "@/pages/analytics/components/table/PortfolioTableHeaderCell.vue";

@Component({
  components: { PortfolioTableHeaderCell },
})
export default class PortfolioTableHeader extends Vue {}
